export default "__VITE_ASSET__3abfe363__"